import type { CandidateFileType } from '@/types/candidates';

export const FILE_TYPE_LABEL: Record<CandidateFileType, string> = {
  CV: 'CV',
  TEST_TASK: 'Test tasks',
  PORTFOLIO: 'Portfolio',
  OTHER: 'Other',
};

export const FILE_TYPE_GROUP_ORDER: CandidateFileType[] = [
  'CV',
  'TEST_TASK',
  'PORTFOLIO',
  'OTHER',
];

export interface FileIconMeta {
  tone: 'pdf' | 'doc' | 'zip' | 'image' | 'text' | 'other';
  ext: string;
  colorClass: string;
}

export function getFileIconMeta(mimeType: string, filename?: string): FileIconMeta {
  if (mimeType === 'application/pdf') {
    return { tone: 'pdf', ext: 'PDF', colorClass: 'bg-red-500/15 text-red-600 dark:text-red-400' };
  }
  if (
    mimeType === 'application/msword' ||
    mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ) {
    return {
      tone: 'doc',
      ext: 'DOC',
      colorClass: 'bg-blue-500/15 text-blue-600 dark:text-blue-400',
    };
  }
  if (mimeType === 'application/zip' || mimeType === 'application/x-zip-compressed') {
    return {
      tone: 'zip',
      ext: 'ZIP',
      colorClass: 'bg-muted text-muted-foreground',
    };
  }
  if (mimeType.startsWith('image/')) {
    return {
      tone: 'image',
      ext: mimeType.replace('image/', '').toUpperCase(),
      colorClass: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400',
    };
  }
  if (mimeType === 'text/plain') {
    return {
      tone: 'text',
      ext: 'TXT',
      colorClass: 'bg-slate-500/15 text-slate-600 dark:text-slate-300',
    };
  }
  const ext = (filename?.split('.').pop() ?? 'FILE').toUpperCase().slice(0, 5);
  return {
    tone: 'other',
    ext,
    colorClass: 'bg-muted text-muted-foreground',
  };
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  const mb = bytes / (1024 * 1024);
  return `${mb >= 10 ? mb.toFixed(0) : mb.toFixed(1)} MB`;
}
